import { render, staticRenderFns } from "./CustomForm.vue?vue&type=template&id=612fd504&scoped=true&"
import script from "./CustomForm.vue?vue&type=script&lang=ts&"
export * from "./CustomForm.vue?vue&type=script&lang=ts&"
import style0 from "./CustomForm.vue?vue&type=style&index=0&id=612fd504&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612fd504",
  null
  
)

export default component.exports